import {
    SET_USER,
    CLEAR_USER,
    REFRESH_CURRENT_USER
  } from "../actions/types";
  import { jwtDecode } from "jwt-decode";

    const isEmpty = require("is-empty");
  
  const initialState = {
    isAuthenticated: false,
    user: {},
    loading: false,
    access_token:null,
    refresh_token:null
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case SET_USER:
        return {
          ...state,
          isAuthenticated: !isEmpty(action.payload),
          user: action.payload.user,
          access_token:action.payload.access_token,
          refresh_token:action.payload.refresh_token,
          loading:false
        };
      case CLEAR_USER:
        return {
            isAuthenticated: false,
            user: {},
            loading: false,
            access_token:null,
            refresh_token:null 
        }
      case REFRESH_CURRENT_USER:
        return {
          ...state,
          isAuthenticated: !isEmpty(action.payload),
          access_token:action.payload.access_token,
          refresh_token:action.payload.refresh_token,
          user:{
            ...state.user,exp:jwtDecode(action.payload.access_token).exp
          }
        }
  
      default:
        return state;
    }
  }
  